// Module
var code = "<h3>Connect next component</h3> <div class=\"available-nodes\"></div> ";
// Exports
export default code;